<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<section
  nodaSwipe
  class="articles-blocks"
  (swipeLeft)="changePage.emit(1)"
  (swipeRight)="changePage.emit(-1)"
>
  @for (article of articles(); track article.path) {
    <a
      [queryParamsHandling]="'merge'"
      [routerLink]="getLang(article)"
      (dragstart)="$event.preventDefault()"
    >
      <article
        class="articles-blocks__item item"
        [class.bg-neutral]="article | map: getColorBlack"
        [style.background-color]="article | map: getBackgroundColor"
      >
        @if (getImageUrl(article); as url) {
          <img
            alt="article-picture"
            class="item__img"
            [src]="url"
          />
        }
        @if (getIconUrl(article); as url) {
          <img
            alt="article-icon"
            class="item__icon"
            [src]="url"
          />
        }

        <span class="item__date">{{ article.publishedAt | date: 'dd.MM.YYYY' }}</span>
        <div class="item__wrapper">
          <div class="item__badges">
            @for (badge of article.preview.tags.data; track badge.id) {
              <noda-articles-badge
                [badgeClasses]="getBadgeClasses(article)"
                [badgeParams]="{ tag: badge.attributes.value }"
                [text]="badge.attributes.name"
              />
            }
          </div>
          <h3
            class="item__title"
            [innerHTML]="article.title"
          ></h3>
        </div>
      </article>
    </a>
  }
</section>
